import './taka/scroll-anime'
import './taka/smart-crossfade'
import './taka/slick.min'
import './taka/velocity.min'
import './taka/common'

import './nav-main-mobile'
import './home-slide'
import '../zzl-lib/formSuppressSubmit'
import { initAjaxzip3OnInput } from './../zzl-lib/ajaxzip3'

import * as formCheckSingle from './../zzl-lib/form-check-single'

initAjaxzip3OnInput()

formCheckSingle.register('.js-form-check-single')
